module.exports = __webpack_public_path__ + "img/cities-of-gold.d4474bb8.jpg";